import React, { useContext, useEffect, useState } from "react";
import { Collapse, Navbar, NavbarToggler } from "reactstrap";
import { useNavigate } from "react-router-dom";
import "./NavMenu.css";
import { LoginContext } from "../../context/login/LoginContext";
import { ContactContext } from "../../context/contact/ContactContext";
import LanguageSelect from "../../languageSelect";
import { useTranslation } from "react-i18next";
import stylesCss, {
  CSSMenuItem,
  CSSMenuItemTittle,
  CssNativeSelect1,
} from "./style";
import NavMenuLife from "../NavMenuLife";

const NavMenu = () => {
  const Classes = stylesCss;
  const { upLogoutRedirect } = useContext(LoginContext);
  let navigate = useNavigate();
  const { t } = useTranslation();
  const {
    isActivePrimary,
    isActiveSecondary,
    getStatesContact,
    vendorInformation,
  } = useContext(ContactContext);
  const [collapsedNav2, setCollapsedNav2] = useState(true);
  const updateCollapsedNav2 = () => setCollapsedNav2(!collapsedNav2);
  const handleLogOut = () => {
    upLogoutRedirect();
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getStatesContact()]);
    };
    fetchData2();
  }, []);

  return (
    <div
      style={{
        zIndex: 2,
        position: "fixed",
        backgroundColor: "white",
        width: "100%",
        top: 0,
      }}
    >
      <NavMenuLife />
      <Navbar
        id="navPortal"
        className="navbar-expand-lg navbar-toggleable-lg ng-white border-bottom"
        light
      >
        <NavbarToggler onClick={updateCollapsedNav2} className="mr-4" />
        <Collapse
          className="d-lg-inline-flex flex-lg-row-reverse cssNav"
          isOpen={!collapsedNav2}
          navbar
        >
          {isActivePrimary ? (
            <ul className="navbar-nav flex-grow">
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("billing")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={2}
                  onClick={() => navigate("/Vendor/AccountStatus")}
                >
                  {t("bankStatement")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("purchaseOrders")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={2}
                  onClick={() => navigate("/Vendor/Purch/Open")}
                >
                  {t("openOrder")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={3}
                  onClick={() => navigate("/Vendor/Purch/Closed")}
                >
                  {t("closedOrder")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={4}
                  onClick={() => navigate("/Vendor/Purch/Recieved")}
                >
                  {t("orderReceived")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("informationManagement")}
                </CSSMenuItem>
                <CSSMenuItemTittle disabled>
                  {t("informationManagement").toUpperCase()}
                </CSSMenuItemTittle>
                <CSSMenuItem
                  value={2}
                  onClick={() => navigate("/Vendor/Contact/Approvals")}
                >
                  {t("approvals")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={3}
                  onClick={() => navigate("/Vendor/Carrier")}
                >
                  {t("carriers")}
                </CSSMenuItem>
                <CSSMenuItem style={{ padding: 3 }} divider />

                <CSSMenuItemTittle disabled>
                  {t("supplierInformation").toUpperCase()}
                </CSSMenuItemTittle>
                <CSSMenuItem
                  value={4}
                  onClick={() => navigate("/Vendor/CompanyInformation")}
                >
                  {t("companyInformation")}
                </CSSMenuItem>
                {/* <CSSMenuItem
                  value={5}
                  onClick={() => navigate("/Vendor/GeneralInformation")}
                >
                  {t("generalInformation")}
                </CSSMenuItem> */}
                {/* {vendorInformation.country === "ECU" && (
                  <CSSMenuItem
                    value={6}
                    onClick={() => navigate("/Vendor/Documentation")}
                  >
                    {t("documentation")}
                  </CSSMenuItem>
                )} */}
                <CSSMenuItem style={{ padding: 3 }} divider />
                <CSSMenuItemTittle disabled>
                  {t("bankInformation").toUpperCase()}
                </CSSMenuItemTittle>
                {/* <CSSMenuItem
                  value={7}
                  onClick={() => navigate("/Vendor/BankInformation")}
                >
                  {t("informationManagement")}
                </CSSMenuItem> */}
                <CSSMenuItem
                  value={8}
                  onClick={() => navigate("/Vendor/Bank/Create")}
                >
                  {t("createAccount")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("account")}
                </CSSMenuItem>
                <CSSMenuItem value={2} onClick={() => navigate("/")}>
                  {t("myInformation")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={3}
                  onClick={() => navigate("/Contact/Information/Update")}
                >
                  {t("updtInfo")}
                </CSSMenuItem>
                {/* <CSSMenuItem value={4} onClick={() => navigate("/")}>
                  {t("deleteInformation")}
                </CSSMenuItem> */}
                <CSSMenuItem
                  value={5}
                  onClick={() => navigate("/Contact/Information/Download")}
                >
                  {t("repInfo")}
                </CSSMenuItem>{" "}
                value={6}
                <CSSMenuItem onClick={() => handleLogOut()}>
                  {t("logout")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <LanguageSelect />
            </ul>
          ) : isActiveSecondary ? (
            <ul className="navbar-nav flex-grow">
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("billing")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={2}
                  onClick={() => navigate("/Vendor/AccountStatus")}
                >
                  {t("bankStatement")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("purchaseOrders")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={2}
                  onClick={() => navigate("/Vendor/Purch/Open")}
                >
                  {t("openOrder")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={3}
                  onClick={() => navigate("/Vendor/Purch/Closed")}
                >
                  {t("closedOrder")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={4}
                  onClick={() => navigate("/Vendor/Purch/Recieved")}
                >
                  {t("orderReceived")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("account")}
                </CSSMenuItem>
                <CSSMenuItem value={2} onClick={() => navigate("/")}>
                  {t("myInformation")}
                </CSSMenuItem>
                <CSSMenuItem
                  value={3}
                  onClick={() => navigate("/Contact/Information/Update")}
                >
                  {t("updtInfo")}
                </CSSMenuItem>
                {/* <CSSMenuItem value={4} onClick={() => navigate("/")}>
                  {t("deleteInformation")}
                </CSSMenuItem> */}
                <CSSMenuItem
                  value={5}
                  onClick={() => navigate("/Contact/Information/Download")}
                >
                  {t("repInfo")}
                </CSSMenuItem>
                <CSSMenuItem value={6} onClick={() => handleLogOut()}>
                  {t("logout")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <LanguageSelect />
            </ul>
          ) : (
            <ul className="navbar-nav flex-grow">
              <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                <CSSMenuItem value={1} style={{ display: "none" }}>
                  {t("account")}
                </CSSMenuItem>
                <CSSMenuItem value={2} onClick={() => handleLogOut()}>
                  {t("logout")}
                </CSSMenuItem>
              </CssNativeSelect1>
              <LanguageSelect />
            </ul>
          )}

          {/* <ul className="navbar-nav flex-grow">
            {(isActivePrimary || isActiveSecondary) && (
              <>
                <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                  <CSSMenuItem value={1} style={{ display: "none" }}>
                    {t("billing")}
                  </CSSMenuItem>
                  <CSSMenuItem
                    onClick={() => navigate("/Vendor/AccountStatus")}
                  >
                    {t("bankStatement")}
                  </CSSMenuItem>
                </CssNativeSelect1>
                <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                  <CSSMenuItem value={1} style={{ display: "none" }}>
                    {t("purchaseOrders")}
                  </CSSMenuItem>
                  <CSSMenuItem onClick={() => navigate("/Vendor/Purch/Open")}>
                    {t("openOrder")}
                  </CSSMenuItem>
                  <CSSMenuItem onClick={() => navigate("/Vendor/Purch/Closed")}>
                    {t("closedOrder")}
                  </CSSMenuItem>
                  <CSSMenuItem
                    onClick={() => navigate("/Vendor/Purch/Recieved")}
                  >
                    {t("orderReceived")}
                  </CSSMenuItem>
                </CssNativeSelect1>
                {isActivePrimary && (
                  <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
                    <CSSMenuItem value={1} style={{ display: "none" }}>
                      {t("informationManagement")}
                    </CSSMenuItem>
                    <CSSMenuItemTittle disabled>
                      {t("informationManagement").toUpperCase()}
                    </CSSMenuItemTittle>
                    <CSSMenuItem
                      onClick={() => navigate("/Vendor/Contact/Approvals")}
                    >
                      {t("approvals")}
                    </CSSMenuItem>
                    <CSSMenuItem onClick={() => navigate("/Vendor/Carrier")}>
                      {t("carriers")}
                    </CSSMenuItem>
                    <CSSMenuItem style={{ padding: 3 }} divider />

                    <CSSMenuItemTittle disabled>
                      {t("supplierInformation").toUpperCase()}
                    </CSSMenuItemTittle>
                    <CSSMenuItem
                      onClick={() => navigate("/Vendor/CompanyInformation")}
                    >
                      {t("companyInformation")}
                    </CSSMenuItem>
                    <CSSMenuItem
                      onClick={() => navigate("/Vendor/GeneralInformation")}
                    >
                      {t("generalInformation")}
                    </CSSMenuItem>
                    {vendorInformation.country === "ECU" && (
                      <CSSMenuItem
                        onClick={() => navigate("/Vendor/Documentation")}
                      >
                        {t("documentation")}
                      </CSSMenuItem>
                    )}
                    <CSSMenuItem style={{ padding: 3 }} divider />
                    <CSSMenuItemTittle disabled>
                      {t("bankInformation").toUpperCase()}
                    </CSSMenuItemTittle>
                    <CSSMenuItem
                      onClick={() => navigate("/Vendor/BankInformation")}
                    >
                      {t("informationManagement")}
                    </CSSMenuItem>
                    <CSSMenuItem
                      onClick={() => navigate("/Vendor/Bank/Create")}
                    >
                      {t("createAccount")}
                    </CSSMenuItem>
                  </CssNativeSelect1>
                )}
              </>
            )}
            <CssNativeSelect1 value={1} sx={Classes.CssSelect}>
              <CSSMenuItem value={1} style={{ display: "none" }}>
                {t("account")}
              </CSSMenuItem>

              {(isActivePrimary || isActiveSecondary) && (
                <>
                  <CSSMenuItem onClick={() => navigate("/")}>
                    {t("myInformation")}
                  </CSSMenuItem>
                  <CSSMenuItem
                    onClick={() => navigate("/Contact/Information/Update")}
                  >
                    {t("updtInfo")}
                  </CSSMenuItem>
                  <CSSMenuItem onClick={() => navigate("/")}>
                    {t("deleteInformation")}
                  </CSSMenuItem>
                  <CSSMenuItem onClick={() => navigate("/")}>
                    {t("repInfo")}
                  </CSSMenuItem>
                </>
              )}
              <CSSMenuItem onClick={() => handleLogOut()}>
                {t("logout")}
              </CSSMenuItem>
            </CssNativeSelect1>
            <LanguageSelect />
          </ul> */}
        </Collapse>
      </Navbar>
    </div>
  );
};

export default NavMenu;
